// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3t1jT","title":"ClientInsurance_title__1k0kK","itemText":"ClientInsurance_itemText__3uK8O"};